var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateSignUpBenefits4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.742,
    height: 44.499,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4717",
    x: 0,
    y: 0,
    width: 43.742,
    height: 44.499,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4713",
    "data-name": "Rectangle 4713",
    width: 18.171,
    height: 11.408,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24420",
    "data-name": "Group 24420",
    transform: "translate(-73.531 -686)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 73.53, 686)",
    filter: "url(#Rectangle_4717)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4717-2",
    "data-name": "Rectangle 4717",
    width: 25.742,
    height: 26.499,
    rx: 4,
    transform: "translate(9 6)",
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24410",
    "data-name": "Group 24410",
    transform: "translate(86.317 699.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24409",
    "data-name": "Group 24409",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46388",
    "data-name": "Path 46388",
    d: "M151.465,7.5a2.277,2.277,0,1,1-2.277,2.277A2.277,2.277,0,0,1,151.465,7.5Z",
    transform: "translate(-142.379 -7.158)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46389",
    "data-name": "Path 46389",
    d: "M288.722,15.5a1.673,1.673,0,1,1-1.673,1.673A1.673,1.673,0,0,1,288.722,15.5Z",
    transform: "translate(-273.949 -14.793)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46390",
    "data-name": "Path 46390",
    d: "M39.474,15.5A1.673,1.673,0,1,1,37.8,17.173,1.673,1.673,0,0,1,39.474,15.5Z",
    transform: "translate(-36.076 -14.793)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46391",
    "data-name": "Path 46391",
    d: "M264.351,88.8h-1.224a2.452,2.452,0,0,0-2.255,1.506,3.331,3.331,0,0,1,1.327,2.4h3.968a.627.627,0,0,0,.627-.627v-.835A2.451,2.451,0,0,0,264.351,88.8Z",
    transform: "translate(-248.966 -84.751)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46392",
    "data-name": "Path 46392",
    d: "M13.423,90.311a2.452,2.452,0,0,0-2.255-1.506H9.944A2.451,2.451,0,0,0,7.5,91.249v.835a.627.627,0,0,0,.627.627H12.1A3.33,3.33,0,0,1,13.423,90.311Z",
    transform: "translate(-7.158 -84.752)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46393",
    "data-name": "Path 46393",
    d: "M112.764,113.448h2.645a.854.854,0,0,0,.854-.854V110.6a3.336,3.336,0,0,0-3.326-3.326H111.27a3.336,3.336,0,0,0-3.326,3.326v1.99a.854.854,0,0,0,.854.854h4.609",
    transform: "translate(-103.018 -102.382)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateSignUpBenefits4);
export default __webpack_public_path__ + "static/media/candidate-sign-up-benefits-4.7d0ed57b0a5e2fc789a3b7dc448808e8.svg";
export { ForwardRef as ReactComponent };